import {
  Box,
  Table,
  Tbody,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FollowupLogsTableRow } from "./FollowupLogsTableRow";
import FollowupLogDataService from "../../services/FollowupLogs";
import { useContext, useEffect, useState } from "react";
import { appContext } from "../../Context/AppContext";

export const FollowupLogsTable = () => {
  const { pageId } = useContext(appContext);
  const [data, setData] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalFollowuplogs, setTotalFollowuplogs] = useState(0);
  const [page, setPage] = useState(1);

  const fetchData = () => {
    FollowupLogDataService.getFollowuplogs(page, pageSize)
      .then((res) => {
        setData(res.data.data);
        setTotalFollowuplogs(res.data.total);
        setTotalPages(res.data.data.totalPages);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchData();
  }, [pageId, page]);

  useEffect(() => {
    setPage(1);
  }, [pageId]);

  return (
    <Box w="100%">
      <Box w="100%" bg="white" overflowX="scroll">
        <Table variant="simple" size="sm" border="1px solid gray" layout="auto">
          <Thead bg="#70afaf">
            <Tr>
              <Th px={2} minWidth="150px">
                User Email
              </Th>
              <Th px={2} minWidth="150px">
                Expert
              </Th>
              <Th px={2} minWidth="150px">
                Channel
              </Th>
              <Th px={2} minWidth="150px">
                Template Id
              </Th>
              <Th px={2} minWidth="120px">
                Original Status
              </Th>
              <Th px={2} minWidth="150px">
                Current Status
              </Th>
              <Th px={2} minWidth="150px">
                Followup Date Time
              </Th>
               <Th px={2} minWidth="50px">
               Delete
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((el: any) => (
              <FollowupLogsTableRow
                el={el}
                func={fetchData}
              />
            ))}
          </Tbody>
        </Table>
      </Box>
      <div className="flex row m-0 pagination">
        <div className="col-sm-6 p-lg-0">
          <p style={{ fontSize: "16px", paddingLeft: "12px" }}>
            Showing {(page - 1) * pageSize + 1} to{" "}
            {page * pageSize > totalFollowuplogs
              ? totalFollowuplogs
              : page * pageSize}{" "}
            of {totalFollowuplogs} entries
          </p>
        </div>
        <div className="col-sm-6 p-lg-0 text-right">
          <div className="btn-group" role="group">
            <button
              type="button"
              className={
                page === 1 ? "btn action-btn disabledButton " : "btn action-btn"
              }
              onClick={() => setPage(page - 1)}
              disabled={page === 1 ? true : false}
            >
              {"<< Previous"}
            </button>
            <button type="button" className="btn action-btn selected">
              {page}
            </button>
            <button
              type="button"
              className={
                page === totalPages || totalPages === 0
                  ? "btn action-btn disabledButton "
                  : "btn action-btn"
              }
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages || totalPages === 0 ? true : false}
            >
              {"Next >>"}
            </button>
          </div>
        </div>
      </div>
    </Box>
  );
};
